/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React, { memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Tab, Tabs } from '@mui/material';

import useTopPanel from 'hooks/useTopPanel';

import Template from './tabs/Template';
import Sending from './tabs/Sending';

function Settings() {
  const [tabIndex, setTabIndex] = useState(1);

  const { t, i18n } = useTranslation();
  const { setComponent } = useTopPanel();

  const handleChangeTab = (event, newValue) => {
    setTabIndex(() => newValue);
  };
  useEffect(() => {
    setComponent(
      <div className='component-title'>{t('settings.telegram.title')}</div>
    );
  }, [i18n.language]);

  return (
    <div className='h-full'>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', width: '100%' }}>
        <Tabs value={tabIndex} onChange={handleChangeTab} type='callsHistory'>
          <Tab label={t('settings.telegram.tabs.sending')} value={1} />
          <Tab label={t('settings.telegram.tabs.template')} value={2} />
        </Tabs>
      </Box>

      <div className='w-full p-5 pb-1 h-[calc(100%-60px)] overflow-y-auto my-scroll'>
        {tabIndex == 1 && <Sending />}
        {tabIndex == 2 && <Template />}
      </div>
    </div>
  );
}

export default memo(Settings);
